import { all } from 'redux-saga/effects';

import formSaga from './sagas/formSaga';
import reportSaga from './sagas/reportSaga';
import referencesSaga from './sagas/referencesSaga';
import modulesSaga from './sagas/modulesSaga';
import contactFormSaga from './sagas/contactFormSaga';
import countSaga from './sagas/counterSaga';

export default function* rootSaga() {
  yield all([
    formSaga(),
    reportSaga(),
    referencesSaga(),
    modulesSaga(),
    contactFormSaga(),
    countSaga(),
  ]);
}
